var _effectorFileName = "/src/apps/providers/with-providers.ts";
import { compose } from '@effable/misc';
import { withBalancer } from './with-balancer';
import { withEffector } from './with-effector';
import { withFresnel } from './with-fresnel';
import { withI18n } from './with-i18n';
import { withTheme } from './with-theme';
export const withProviders = compose(withI18n, withEffector, withTheme, withFresnel, withBalancer);